<template>
    <div class="jd_item">
        <div class="header">

        </div>

        <div class="main">
            <div class="body">
                <div class="title">活动列表</div>
                <div class="list">
                    <div class="item" v-for="(item,index) in subItemList" :key="index" @click="goDetail(item)">
                        <img :src="item.icon"/>
                        <div>{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "./index.less"

export default {
    data() {
        return {
            subItemList: [],
            detail: {},
            item_id: this.$route.params.item_id,    
        }
    },
    mounted() {
        this.getItemInfo();
    },
    methods: {
        getItemInfo() {
            this.subItemList = [];
            this.$api.sports.getItemSubs({ itemid: this.item_id }).then((res) => {
                this.subItemList = res.data.list;
            });
        },
        goDetail(val) {
            if(val.register_type == 2){
                window.location.href = val.register_type_value
                return
            }
            if(val.register_type_value){
                if(val.register_type_value.indexOf('http')!=-1){
                    window.location.href = val.register_type_value
                } else {
                    wx.miniProgram.navigateTo({
                        url: val.register_type_value
                    })
                }
                
                return
            }
            this.$router.push({name:'sportsDetail',params:{sports_id:val.sports_id,item_id:this.item_id,item_sub_id:val.id}})   
        },
    }
}
</script>